import React from 'react';

import {RequestResetPasswordForm} from '@features/Password/RequestResetPassword';

export const ForgotRequestPage = () => <RequestResetPasswordForm />;
